type ToggleSwitchProps = {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  /** Accessible label */
  "aria-label"?: string;
};

/**
 * Unified toggle for forms and CrudPanel — fixed track size, brand on-state.
 */
export default function ToggleSwitch({
  checked,
  onChange,
  disabled,
  "aria-label": ariaLabel,
}: ToggleSwitchProps) {
  const on = Boolean(checked);
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => !disabled && onChange(!on)}
      className={`relative inline-flex h-7 w-12 shrink-0 items-center rounded-full border-2 border-transparent transition-colors duration-200 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-navy-900 ${
        on
          ? "bg-brand-500 shadow-[inset_0_1px_2px_rgba(0,0,0,0.12)]"
          : "bg-slate-300 dark:bg-slate-600"
      } ${disabled ? "cursor-not-allowed opacity-45" : "cursor-pointer hover:brightness-[1.03] active:scale-[0.98] dark:hover:brightness-110"}`}
    >
      <span
        className={`flex w-full items-center px-0.5 transition-[justify-content] duration-200 ease-out ${
          on ? "justify-end" : "justify-start"
        }`}
      >
        <span
          className={`pointer-events-none h-5 w-5 rounded-full border border-white/40 bg-white shadow-sm ring-1 ring-black/5 transition-transform duration-200 dark:ring-white/10 ${
            on ? "shadow-md" : ""
          }`}
        />
      </span>
    </button>
  );
}
